<template>
<div id="app" class="w3-container">
  <div id="header">
    <h1 class="logo"><font-awesome-icon :icon="['far', 'snowflake']" style="margin-right:10px;"/>{{ config.websiteTitle }}</h1>

    <p style="float: right; margin: 10px;">
      <a v-if="isLoggedIn" href="/articles/personal" style="margin-right: 10px;">Authorized as: «{{ username }}» </a>
      <a v-if="!isLoggedIn" href="/login">Login</a>
      <button v-else @click="logout">Logout</button>
    </p>
    
    <p v-html="config.description"></p>
  </div>
  
  <div id="sidebar">
    <a href="/">Home</a>
    <a href="/articles">Local Floor</a>
    <a href="/articles/federated">Federated Floor</a>
    <a href="/articles/submit">Submit New</a>
    <a href="/alliance">Alliance</a>
    <a v-if="isAdmin" href="/admin/articles/queue">Manage</a>
    <a v-if="isAdmin" href="/admin/invite">Invite</a>
    <a v-if="isAdmin" href="/admin/user/list">Members</a>
    <a v-if="isLoggedIn" :href="`/profile?username=${ username }`">Profile</a>
    <a v-if="isLoggedIn" href="/users/update">Update User Info</a>
    <!-- <a href="/policy">Policy Report</a> -->
    <!-- Add more menu items as needed -->
  </div>

  <div id="content">
    <router-view></router-view>
  </div>

  <footer style={styles.footer}>
    <p style={styles.text}>
      © {{ config.year }} {{ config.copyrightOwner }}. All rights reserved.
    </p>
    <p style={styles.text}>
      Contact a Librarian: <a :href="`mailto:${config.librarianEmail}`"> {{ config.librarianEmail }}</a>
    </p>
  </footer>

</div>
</template>

<script>
// import 'yorha/dist/yorha.min.css';
import config from './config';
import './assets/app.css'

// Supports weights 300-800
import '@fontsource-variable/open-sans';

export default {
  name: 'App',
  data() {
      const username = sessionStorage.getItem('username');
      return {
          isLoggedIn: false,
          config,
          username
      };
  },
  created() {
      // Check if the JWT token is present in sessionStorage
      this.isLoggedIn = !!sessionStorage.getItem('jwt');
      this.isAdmin = sessionStorage.getItem('is_admin');
      
      document.title = this.config.websiteTitle;
  },
  methods: {
      logout() {
          // Clear the token
          sessionStorage.removeItem('jwt');
          sessionStorage.removeItem('is_admin');

          // Update the state
          this.isLoggedIn = false;
          this.isAdmin = false;

          // Redirect to login page
          this.$router.push('/login');
      }
  }

};
</script>

